import { Instruction, ProgramContentType } from "../../BlockComponent";
import { selfCheckTemplate } from "./0-1-A";
import { LastCard } from "../common";

export const Content_0_2_A: ProgramContentType[] = [
  Instruction("typography_0_0_0"),
  Instruction("typography_1_0_0"),
  Instruction("typography_2_0_0"),
  ...selfCheckTemplate,

  ...LastCard,
];
